// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"d9ca419f","213":"9e7bde2b","475":"acfb7b91","580":"361125ff","591":"f0938731","747":"9a57d74c"}[chunkId] + ".chunk.js";
};